import { hash } from 'ohash'
import { useRuntimeConfig } from '#app'
import { useUserData } from '~/composables/account/use-user-data'
import type { HttpResponse } from '~/utils/interface'
import { useLighthouse } from '~/composables/common/use-lighthouse'

interface IParam {
  key?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
}
export function useApi() {
  const { isLighthouseBot } = useLighthouse()

  const request = async (url: string, params: IParam): Promise<HttpResponse> => {
    if (isLighthouseBot) {
      return { data: [] }
    }
    const environment = useRuntimeConfig()
    const { currentUser } = useUserData()
    const token = useCookie('token')
    const { os, device, browser } = getDeviceHeaders()
    
    const { headers: paramsHeaders, ...paramsWithoutHeaders } = params
    let convertedParamsHeaders: Record<string, string> = {}
    if (paramsHeaders) {
      if (paramsHeaders instanceof Headers) {
        paramsHeaders.forEach((value, key) => {
          convertedParamsHeaders[key] = value
        })
      } else {
        convertedParamsHeaders = { ...paramsHeaders } as Record<string, string>
      }
    }
    
    const requestToken = token.value ?? currentUser.value?.token
    const requestGpToken = currentUser?.value.gptoken
    
    const opts = {
      key: hash(['api-fetch', url, params]),
      retry: 0,
      baseURL: environment.public.baseURL,
      headers: {
        'Content-Type': 'application/json',
        os,
        device,
        browser,
        ...convertedParamsHeaders,
        ...(requestToken ? { token: requestToken } : {}),
        ...(requestGpToken ? { gpToken: requestGpToken } : {})
      },
      ...paramsWithoutHeaders,
      lazy: false
    }
    let responseData
    try {
      const data = await $fetch(url, opts)
      responseData = typeof data === 'string' ? JSON.parse(data) : data
      return responseData
    } catch (errors) {
      if (typeof errors === 'object' && errors && 'data' in errors) {
        responseData = errors.data
      } else if (errors instanceof Error) {
        responseData = errors.message
      }
    }
    return responseData
  }
  return {
    request
  }
}
